// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import {getToken, isLoggedIn} from './service/auth'
import {checkAA, checkAccountAccess, formatMonthYear, userImageURL} from './service/helpers'
import moment from 'moment'
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'
import $eventHub from './components/Pages/components/eventHub'
import VueCookies from 'vue-cookies'
import vClickOutside from 'v-click-outside'
import VueMeta from 'vue-meta'
import VueSentry from 'vue2-sentry'
import {unPlugin} from './service/unrival-plugin'

Vue.use(VueCookies)
Vue.use(vClickOutside)
Vue.use(VueMeta)

// Add a response interceptor
axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  let errorMessage = error.response && error.response.data ? error.response.data.message : 'Undefined'
  if (error.response && error.response.status === 401) {
    if (router.currentRoute.name === 'logout') {
      window.location.reload()
    } else {
      router.push('/logout')
    }
    // setTimeout(() => {
    //   $eventHub.$emit('displaySystemMessage', errorMessage)
    // }, 1000)
  }
  if (error.response && error.response.status === 403) {
    $eventHub.$emit('displaySystemMessage', errorMessage)
  }
  return Promise.reject(error)
})
// Add a request interceptor
axios.interceptors.request.use((config) => {
  if (isLoggedIn()) {
    config.headers.Authorization = getToken()
  }
  return config
})

Vue.config.productionTip = false

Vue.filter('formatMonthYear', function (date) {
  return formatMonthYear(date)
})
Vue.filter('initials', function (value) {
  value = value.match(/\b\w/g) || []
  return value.map((n) => n[0]).join('').substr(0, 3)
})
Vue.filter('limit20', function (value) {
  if (value.length > 20) {
    return value.substring(0, 20) + '...'
  }
  return value
})

Vue.filter('userImageURL', function (value) {
  return userImageURL(value)
})
Vue.filter('grabIcon', function (url) {
  return 'https://www.google.com/s2/favicons?sz=64&domain_url=' + url
})
Vue.filter('date', function (value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
})
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD MMM YYYY')
  }
})
Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD MMM YYYY HH:mm')
  }
})

Vue.filter('formatDateLong', function (value) {
  if (value) {
    return moment(String(value)).format('MMM Do YYYY')
  }
})
Vue.filter('dateYear', function (value) {
  if (value) {
    return moment(String(value)).format('MMM YYYY')
  }
})
Vue.filter('formatDecimal', function (value) {
  if (value) {
    return (Math.round(value * 100) / 100).toFixed(1)
  }
  return 0
})
Vue.filter('formatInteger', function (value) {
  if (value) {
    return parseInt(value)
  }
  return 0
})

Vue.filter('capital', function (value) {
  value = value.toLowerCase()
  value = value.charAt(0).toUpperCase() + value.slice(1)
  return value.split('_').join(' ')
})

Vue.use(VueCustomTooltip, {
  color: '#30384b',
  background: '#cbcdd2',
  borderRadius: 3,
})

Vue.prototype.$apiUrl = process.env.UNRIVAL_API

Vue.use(VueSentry, {
  enable: process.env.NODE_ENV !== 'development',
  protocol: 'https', // Optional: default is https
  key: 'b1040e81e4154384879d6c5f7b9fbf44',
  project: '6743562',
  config: {} // Optional: custom config
})


Vue.use(unPlugin)

// Sentry.init({
//   Vue,
//   dsn: 'https://7f1e9f5bf53c4a90a91028b9b0101753@o1407871.ingest.sentry.io/6743037',
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ['localhost', 'localhost:8080', /^\//],
//     }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js